// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"7ddf8da0","453":"a492ffeb","573":"89740f0a"}[chunkId] + ".chunk.js";
};